import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

// Pages
import Home from './pages/Home';
import Listings from './pages/Listings';
import YachtDetail from './pages/YachtDetail';
import Guides from './pages/Guides';
import GuideDetail from './pages/GuideDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import CharterCalculator from './pages/CharterCalculator';
import YachtFinder from './pages/YachtFinder';
import DestinationPage from './pages/destinations/DestinationPage';
import CategoryHub from './pages/CategoryHub';
import CategoryListing from './pages/CategoryListing';
import CreateListing from './pages/CreateListing';
import ResetPassword from './pages/ResetPassword';
import AuthCallback from './components/auth/AuthCallback';

// Guide Pages
import YachtEssentials from './pages/guides/YachtEssentials';
import TypesByPropulsion from './pages/guides/TypesByPropulsion';
import TypesByPurpose from './pages/guides/TypesByPurpose';
import HullDesign from './pages/guides/HullDesign';
import BuyingOwnership from './pages/guides/BuyingOwnership';
import MaintenanceSafety from './pages/guides/MaintenanceSafety';
import TrendsFacts from './pages/guides/TrendsFacts';

// Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

function AppContent() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Handle Emergent Auth callback synchronously (before any other routing)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/listings" element={<Listings />} />
        <Route path="/yacht/:id" element={<YachtDetail />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guide/:id" element={<GuideDetail />} />
        {/* Knowledge Hub Guide Routes */}
        <Route path="/guides/essentials" element={<YachtEssentials />} />
        <Route path="/guides/types-propulsion" element={<TypesByPropulsion />} />
        <Route path="/guides/types-purpose" element={<TypesByPurpose />} />
        <Route path="/guides/hull-design" element={<HullDesign />} />
        <Route path="/guides/buying-ownership" element={<BuyingOwnership />} />
        <Route path="/guides/maintenance-safety" element={<MaintenanceSafety />} />
        <Route path="/guides/trends-facts" element={<TrendsFacts />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/calculator" element={<CharterCalculator />} />
        <Route path="/yacht-finder" element={<YachtFinder />} />
        <Route path="/destinations/:slug" element={<DestinationPage />} />
        {/* Marketplace category pages */}
        <Route path="/category/:categorySlug" element={<CategoryHub />} />
        <Route path="/category/:categorySlug/:subSlug" element={<CategoryListing />} />
        <Route path="/list/new" element={<CreateListing />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <Footer />
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
